import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import notificationService from '../../services/notification';

const initialState = {
  loading: false,
  notifications: [],
  error: '',
  params: {
    page: 1,
    perPage: 15,
    type: undefined,
    active: undefined,
  },
  meta: {},
};

export const fetchNotifications = createAsyncThunk(
  'notification/fetchNotifications',
  (params = {}) => {
    return notificationService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchNotifications.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.notifications = Array.isArray(payload?.data) ? payload.data : [];
      state.meta = payload?.meta ?? {};
      if (payload?.meta) {
        state.params.page = payload.meta.current_page ?? payload.meta.page ?? state.params.page;
        state.params.perPage = payload.meta.per_page ?? state.params.perPage;
      }
      state.error = '';
    });
    builder.addCase(fetchNotifications.rejected, (state, action) => {
      state.loading = false;
      state.notifications = [];
      state.error = action.error?.message ?? '';
    });
  },
});

export default notificationSlice.reducer;
